import { AppRadioGroup } from 'components/core/AppRadioGroup/AppRadioGroup';
import { ListPageFormTypeEnum } from '../types';
import { useListPageModalNavigation } from '../hooks/useListPageModalNavigation';

const buttonsSetup = [
  {
    title: 'Standard Setup',
    value: ListPageFormTypeEnum.Unassisted,
    subtitle: 'I will setup the listing using the step-by-step wizard',
  },
  {
    title: 'Assisted Setup',
    value: ListPageFormTypeEnum.Assisted,
    subtitle: 'Have a team member from alluraDirect setup my listing',
  },
];

const SelectSetupType = () => {
  const { pushAssistedUrl, pushUnassistedUrl, isAssistedSetUp } = useListPageModalNavigation();

  return (
    <AppRadioGroup
      buttons={buttonsSetup}
      value={isAssistedSetUp ? ListPageFormTypeEnum.Assisted : ListPageFormTypeEnum.Unassisted}
      setValue={value => (value === ListPageFormTypeEnum.Unassisted ? pushUnassistedUrl() : pushAssistedUrl())}
      isSingleBar
      titleStyle={{ fontSize: '20px' }}
      subtitleStyle={{ fontSize: '12px' }}
    />
  );
};

export default SelectSetupType;
